export interface MasterCampaignStub {
  name: string
  campaignBuilders: MasterCampaignPlanCampaignBuilder[]
}

export interface MasterCampaignPlanCampaignBuilder {
  id: string
  name: string
  segmentTargets: SegmentTarget[]
  shortSummary: string
  longSummary: string
  audienceSummary: string
  geoSummary: string
  seasonalitySummary: string
  campaignType: MasterCampaignPlanCampaignBuilderType
  isOffAdCritter?: boolean
  offAdCritterName?: string
  offAdCritterColor?: string
  intervalBudget: number
  intervalUnit?: IntervalUnit
  intervalFrequency?: number
  intervalDuration?: number
  retargetSite: boolean
  isTotalBudget: boolean
  startDate: moment.Moment
  endDate?: moment.Moment
  zips?: PostalCodeTarget[]
  cpm?: number
  cpc?: number
  marginOfError?: number
  minCpm?: number
  maxCpm?: number
  minCpc?: number
  maxCpc?: number
  includeInProjections: boolean
  includeInGeoHeatmap: boolean
}

export interface PostalCodeTarget {
  name: string
  code: string
}

export interface SegmentTarget {
  name: string
  hierarchy: string[]
}

export enum IntervalUnit {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month'
}

export enum MasterCampaignPlanCampaignBuilderType {
  Internet = 'Internet',
  Billboard = 'Billboard',
  TV = 'TV',
  Audio = 'Audio',
  OffAdCritter = 'OffAdCritter'
}
